<template>
  <v-dialog
    v-bind="$attrs"
    v-on="$listeners"
    v-model="dialog"
    fullscreen
    persistent
    hide-overlay
  >
    <template v-slot:activator="{ on, attrs }">
      <slot
        name="activator"
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <div
      tabindex="0"
      ref="preFocus"
    />
    <v-card
      rounded="0"
    >
      <v-toolbar
        dark
        color="#041E42"
        class="toolbar"
      >
        <slot name="title">
          <h1
            :class="{'heading': $vuetify.breakpoint.mdAndUp, 'heading headingMobile': $vuetify.breakpoint.smAndDown}"
          >
            {{ title }}
          </h1>
        </slot>
        <v-btn
          v-if="showCloseButton"
          icon
          dark
          :small="$vuetify.breakpoint.smAndDown"
          class="closeButton"
          aria-label="close"
          @click="dialog = false"
          @keyup.enter="dialog = false"
        >
          <v-icon color="white">
            mdi-close
          </v-icon>
        </v-btn>
        <slot name="action" />
      </v-toolbar>
      <div class="contentWrapper">
        <slot name="content" />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FullscreenDialog',
  props: {
    title: {
      type: String,
      default: 'Title'
    },
    showCloseButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    dialog: {
      get() {
        return this.$attrs.value;
      },
      set(value) {
        this.$listeners.input && this.$listeners.input(value);
      }
    }
  },
  watch: {
    dialog: {
      handler(val) {
        if (!val) { // false, close the dialog
          this.showMainScrollbar();
        } else {    // true, open the dialog
          setTimeout(() => this.$refs.preFocus?.focus());
          this.hideMainScrollbar();
        }
      }
    }
  },
  methods: {
    hideMainScrollbar() {
      const styleForScrollbar = document.createElement('style');
      styleForScrollbar.id = 'style-for-scrollbar';
      styleForScrollbar.innerHTML = 'html::-webkit-scrollbar { display: none; } html { -ms-overflow-style: none; scrollbar-width: none; }';
      document.head.appendChild(styleForScrollbar);
    },
    showMainScrollbar() {
      const styleForScrollbar = document.getElementById('style-for-scrollbar');
      if (styleForScrollbar) {
        document.head.removeChild(styleForScrollbar);
      }
    }
  },
  updated() {
    // v-dialog adds tabindex=0 in its root element. When the user clicks anywhere in the dialog,
    // this element gets focused, and the scroll fired by arrow down key stops working.
    // This code removes tabindex attribute from the root element
    this.$nextTick(() => {
      const dialog = document.querySelector('.v-dialog__content--active');
      if (dialog && dialog.getAttributeNames().includes('tabindex')) {
        dialog.removeAttribute('tabindex');
      }
    });
  }
}
</script>

<style lang="scss" scoped>
.toolbar {
  min-width: 100%;
  position: fixed;
  z-index: 10;

  .heading {
    margin-left: 60px;
    font-size: 20px;
    width: 100%;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }

  .headingMobile {
    margin-left: 48px;
  }

  .closeButton {
    position: absolute;
    margin-left: 0;

    &:focus {
      border: 2px solid #ffffff !important;
      border-radius: 50% !important;
      outline: none !important;
    }
  }
}

.contentWrapper {
  padding-top: 64px;
}

@media only screen and (max-width: 960px) {
  .contentWrapper {
    padding-top: 56px;
  }
}
</style>
